import { Injectable } from '@angular/core';
import { Address, AddressArt, AddressBase, AddressIdentifier } from '../_interfaces/address';
import { ContactPerson } from '../_interfaces/ContactPerson';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';
import { TicketBase } from '../_interfaces/ticket';
import { HttpService } from './http.service';
import { GeneralService } from './general.service';

@Injectable({
  providedIn: 'root'
})
export class CrmService{

  public addressArts: AddressArt[] = []
  public addressIdentifiers: AddressIdentifier[] = []

  constructor(
    private http: HttpService,
    private generalSrv: GeneralService
  ) { 
    this.loadAddressArts()
  }

  /**
   * Gibt daten von server Zurück
   * @param {string} path Pfad zum Server
   * @returns 
   */
  private async getAPIData<T>(path: string): Promise<HttpFunctionResult<T>>{
    return await this.http.GET<T>({path: path})
  }

  /**
   * Lädt die Arten der Adressen
   * @returns 
   */
  public async loadAddressArts(){

    if(!this.generalSrv.serverVersionGreaterThan("1.11.0") || !this.generalSrv.webConfig?.hasManagerConnection) return
    const result: HttpFunctionResult<AddressArt[]> = await this.getAPIData<AddressArt[]>(`addresses/editinfo/arts`)
    if(result.success) this.addressArts = result.data
    this.addressArts.forEach(aa => {
      switch (aa.id) {
        case 0: aa.icon = "fa-user-business"; break;
        case 1: aa.icon = "fa-truck-fast"; break;
        case 2: aa.icon = "fa-person-question"; break;
        default: aa.icon = "fa-user"; break;
      }
    })
  }

  /**
   * Lädt die Kennungen der Adressen
   * @returns 
   */
  public async loadAddressIdentifiers(){
    if(!this.generalSrv.serverVersionGreaterThan("1.13.1") || !this.generalSrv.webConfig?.hasManagerConnection) return
    const result: HttpFunctionResult<AddressIdentifier[]> = await this.getAPIData<AddressIdentifier[]>(`addresses/editinfo/identifiers`)
    if(result.success) this.addressIdentifiers = result.data
  }

  /**
   * gibt eine Liste von Adressen in der BAsisform zurück
   * @param {string} searchText text nach dem gefiltert werden kann
   * @param {number} limit maximale anzahl die geholt werden soll
   * @param {number} offset anzahl an zeilen die übersprungen werden sollen
   * @returns 
   */
  public async getBasicCrmList(searchText: string, limit: number = 30, offset: number = 0, artId: number = -1, indentifierName: string = "Alle"): Promise<HttpFunctionResult<AddressBase[]>>{
    return await this.getAPIData<AddressBase[]>(`addresses?searchText=${encodeURIComponent(searchText)}&limit=${limit}&offset=${offset}&art=${artId}&identifier=${encodeURIComponent(indentifierName)}`)
  }

  /**
   * Gibt kompletten inhalt eine angegebenen Adresse
   * @param {number} addressId Id der Adresse 
   * @returns 
   */
  public async getSingleAddress(addressId: number): Promise<HttpFunctionResult<Address>>{
    return await this.getAPIData<Address>(`addresses/${addressId}`)
  }

  /**
   * Gibt alle Tickets einer Adresse zurück
   * @param {number} addressId Id der Adresse
   * @returns 
   */
  public async getTicketsByAddressId(addressId: number, searchText: string): Promise<HttpFunctionResult<TicketBase[]>>{
    return await this.getAPIData<TicketBase[]>(`ticket?addressId=${addressId}&sorted=false&searchText=${encodeURIComponent(searchText)}`)
  }

  /**
   * Gibt alle kontaktpersonen einer adresse zurück
   * @param {number} addressId Id der Adresse
   * @param {string} searchText Text nach dem Gefiltert werden kann
   * @returns 
   */
  public async getBasicContactPersonList(addressId: number, searchText: string): Promise<HttpFunctionResult<ContactPerson[]>>{
    return await this.getAPIData<ContactPerson[]>(`addresses/contactpersons/${addressId}?searchText=${encodeURIComponent(searchText)}`)
  }

  /**
   * Updatet die Adressarten
   * @param {AddressArt[]} arts 
   * @returns 
   */
  public async updateAddressArts(arts: AddressArt[]){
    return await this.http.PUT<AddressArt[], AddressArt[]>({
      path: `addresses/editinfo/arts`,
      body: arts
    })
  }

}
